import {isArray} from "lodash"

import {formatDriverName} from "../string"


export default (drivers, component) => {
  if (!isArray(drivers)) return drivers

  return drivers.map((driver) => {
    return {
      value: driver.id,
      label: formatDriverName(component, driver)
    }
  })
}
